













































































































































































































































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import moment from "moment";
import * as SharedRoutes from "@/shared/route-names";
import * as RouteNames from "@/employee/route-names";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import AvidiaForms from "@/employee/components/resources/AvidiaForms.vue";
import AllegacyForms from "@/employee/components/resources/AllegacyForms.vue";
import HsaBankForms from "@/employee/components/resources/HsaBankForms.vue";
import UmbForms from "@/employee/components/resources/UmbForms.vue";
import ElementsForms from "@/employee/components/resources/ElementsForms.vue";
import ElementsFormsInstructions from "@/employee/components/resources/ElementsFormsInstructions.vue";
import UcbForms from "@/employee/components/resources/UcbForms.vue";
import CustomerFormDocuments from "@/employee/components/resources/CustomerFormDocuments.vue";
import TermsFeeSchedule from "@/employee/components/onboarding/TermsFeeSchedule.vue";
import AvidiaTermsFeeSchedule from "@/employee/components/onboarding/AvidiaTermsFeeSchedule.vue";
import AllegacyTermsFeeSchedule from "@/employee/components/onboarding/AllegacyTermsFeeSchedule.vue";
import CombinedStatements from "@/employee/components/landing-pages/hsabank/CombinedStatements.vue";
import TaxDocumentsAllYears from "@/employee/components/landing-pages/hsabank/TaxDocumentsAllYears.vue";
import SecureDocumentUploadComponent from "@/employee/components/landing-pages/SecureDocumentUploadComponent.vue";
import DisclosureLinks from "@/employee/components/investments/drivewealth/DisclosureLinks.vue";
import { BankCustodian } from "@/admin/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import {
  FormDocumentType,
  HsabSsoDestination,
  ManagedExpenseFilterType,
  TermsTab,
  DrivewealthAccountManagementType,
  SignedDocumentKey,
  DrivewealthClosedAccountSummary
} from "@/shared/types";
import ResourcesExternalLinkJumbotrons from "@/employee/components/landing-pages/ResourcesExternalLinkJumbotrons.vue";
import FeeScheduleAndRatesDeepLink from "@/employee/components/landing-pages/hsabank/FeeScheduleAndRatesDeepLink.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCustomerFormDocumentsStore } from "@/employee/store/customerFormDocument";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { isMobileApp } from "@/shared/mobileHelper";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import FeeScheduleAndInterestRates from "@/employee/components/landing-pages/hsabank/FeeScheduleAndInterestRates.vue";

@Component({
  components: {
    FeeScheduleAndInterestRates,
    Tab,
    TabGroup,
    UmbForms,
    ElementsForms,
    ElementsFormsInstructions,
    UcbForms,
    AvidiaForms,
    AllegacyForms,
    CustomerFormDocuments,
    TermsFeeSchedule,
    AvidiaTermsFeeSchedule,
    HsaBankForms,
    AllegacyTermsFeeSchedule,
    SsoDeepLink,
    GenericLoadingSpinner,
    CombinedStatements,
    TaxDocumentsAllYears,
    SecureDocumentUploadComponent,
    FeeScheduleAndRatesDeepLink,
    ResourcesExternalLinkJumbotrons,
    DisclosureLinks
  },
})
export default class Resources extends Vue {
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  portalCustomizationStore = usePortalCustomizationStore();
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  customerFormDocumentStore = useCustomerFormDocumentsStore();
  drivewealthStore = useDrivewealthStore();
  signingDocumentStore = useSigningDocumentStore();

  ManagedExpenseFilterType = ManagedExpenseFilterType;
  FormDocumentType = FormDocumentType;
  moment = moment;
  SharedRoutes = SharedRoutes;

  @Prop()
  symbol: string;

  @Prop()
  year: number;

  readonly bendTermsAndConditionsFile =
      "bend_financial_terms_of_service 20181009.pdf";

  RouteNames = RouteNames;
  TermsTab = TermsTab;
  isHsabAndUserEsignedAgreement = false;

  completedTableFields = [
    {
      key: "accountNumber",
      label: "Account Number",
      thClass: "text-left"
    },
    {
      key: "accountManagementType",
      label: "Account Type",
      thClass: "text-left"
    },
    {
      key: "dateAccountOpened",
      label: "Date Opened",
      thClass: "text-left"
    },
    {
      key: "dateAccountClosed",
      label: "Date Closed",
      thClass: "text-left"
    },
    {
      key: "drivewealthAccountId",
      label: "",
      thClass: "text-left"
    },
  ];

  get showSecureDocumentUpload (): boolean {
    return (
        this.custodianSettingsStore.userCustodian === BankCustodian.HsaBank &&
        this.featureFlagStore.featureFlagsAvailable &&
        !this.featureFlagStore.flags.bend16780CombinedAccountSummariesEnabled
    );
  }

  get showStatementTab (): boolean {
    return (
        this.custodianSettingsStore.userCustodian === BankCustodian.HsaBank &&
        this.featureFlagStore.featureFlagsAvailable &&
        this.featureFlagStore.flags.bend16780CombinedAccountSummariesEnabled
    );
  }

  get activeTabIndex (): number {
    return Array.from(this.tabChoiceUrls.keys())
      .findIndex(i => i.params.symbol === this.symbol);
  }

  @Watch("this.closedAccountsLoaded")
  get tabChoiceUrls () {
    if (this.hsabAccountNotReady && this.featureFlagStore.flags.bend30439UpfrontContributions) {
      return new Map([
        [ { name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesTaxForms } }, "Tax Documents" ]
      ]);
    }

    const tabMap = new Map([
      [ { name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesDownloadableFiles } }, "Forms" ]
    ]);
    if (this.showLinksTab) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourceLinks } }, "Learning Center");
    }
    if (this.showStatementTab) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesDocuments } },
           "Account Summaries");
      if (this.hasHsa) {
        tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesTaxForms } },
            "Tax Documents");
      }
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesSecureDocumentUpload } },
           "Secure Document Upload");
    }
    if (this.custodianSettingsStore.displayFooterLegalSection) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesFees } },
          "Fee & Interest Schedule");
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesFinancialInstitutionTerms } },
          "Financial Institution Terms");
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesHsaTerms } }, "HSA Terms");
    }
    if (this.hasDrivewealthInvestmentAccount) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesHsaInvest } }, "HSA Invest");
    }

    if (this.displayClosedAccountsTab) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesClosedInvestmentAccounts } }, "Closed HSA Invest Accounts");
    }

    return tabMap;
  }

  get displayClosedAccountsTab (): boolean {
    return this.displayClosedInvestmentAccounts &&
        this.closedAccountsLoaded &&
        !!this.drivewealthStore.closedAccounts.length;
  }

  get hasMultipleTabs (): boolean {
    return this.tabChoiceUrls.size > 1;
  }
  get hasHsa (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount;
  }

  get hasDrivewealthInvestmentAccount (): boolean {
    return this.drivewealthStore.hasAccountIdOrIds;
  }

  get displayClosedInvestmentAccounts (): boolean {
    return this.custodianSettingsStore.displayClosedInvestmentAccountsList;
  }

  get closedAccountsLoaded (): boolean {
    return this.drivewealthStore.closedAccountsLoaded;
  }

  get closedAccounts (): DrivewealthClosedAccountSummary[] {
    return this.drivewealthStore.closedAccounts;
  }

  get hsabAccountNotReady (): boolean {
    return this.hsabAccountsStore.allHsabAccounts.length === 0 &&
        this.custodianSettingsStore.isHsaBankCustodian;
  }

  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings();
    this.partnerPortalStore.getPartnerPortalStatus();
    this.customerFormDocumentStore.loadDocuments();
    this.$on("tab-clicked", (event, tab) => {
      event.preventDefault();
    });
    this.loadSignedDocumentKeys();
    this.signingDocumentStore.getHsabDrivewealthAccountSignature()
        .then(result => {
          this.isHsabAndUserEsignedAgreement = this.signingDocumentStore.hsabDrivewealthAccountSignatureIsSigned &&
              this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
        });
    if (this.displayClosedInvestmentAccounts) {
      this.drivewealthStore.loadClosedAccounts({});
    }

    if (this.hsabAccountNotReady && this.featureFlagStore.flags.bend30439UpfrontContributions) {
      this.$router.push({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesTaxForms } });
    }
  }

  @Watch("accountTypeKeys", { deep: true })
  loadSignedDocumentKeys (): void {
    this.accountTypeKeys.forEach(x => {
      this.signingDocumentStore.getSignedDocumentKey(x);
    });
  }

  get disclosureDocumentKeys (): SignedDocumentKey[] {
    return this.accountTypeKeys.map(x => {
      const documentKey = drivewealth.advisoryDocumentKeyMap[x];

      return { accountType: x, documentKey, pathToFile: null };
    });
  }

  get accountTypeKeys (): DrivewealthAccountManagementType[] {
    return this.drivewealthStore.accountIds.map(x => {
      return this.drivewealthStore.accountManagementType(x);
    });
  }

  get hsabEsignDocumentKey (): string {
    return this.signingDocumentStore.drivewealthAccountSignatureDocumentKey;
  }

  get documentKeys (): SignedDocumentKey[] {
    return this.signingDocumentStore.signedKeys || this.disclosureDocumentKeys;
  }

  getDocumentSignatureUrl (documentKey): string {
    const url = window.location.protocol + "//" + window.location.host + "/#/" + "document-signature-view" + "?documentKey=" + documentKey;
    return url;
  }

  open (documentKey: string, pathToFile: string): void {
    if (pathToFile) {
      this.$router.push({ path: pathToFile });
    } else {
      this.$router.push({ name: RouteNames.DocumentSignatureView, query: { documentKey } });
    }
  }

  get isMobile (): boolean {
    return isMobileApp();
  }

  get hsaStorePartnerLink (): string {
    return "https://hsastore.com/?a_aid=5e2f0892a95de&utm_source=Bend+HSA&utm_medium=TPA+Portal+Proprietary+Link&utm_campaign=TPA+Partner";
  }

  get hsaBluebookLink (): string {
    return "https://www.healthcarebluebook.com/";
  }

  get hasInstructionsWidget (): boolean {
    return (
        this.custodianSettingsStore.displayFaqInstructions &&
        this.custodianSettingsStore.faqInstructionsTemplate.length > 0
    );
  }

  get termsAndConditionsHref (): string {
    return `/${this.bendTermsAndConditionsFile}`;
  }

  get showAllegacyDynamicFees (): boolean {
    return (
        this.custodianSettingsStore.userCustodian === BankCustodian.Allegacy &&
        this.featureFlagStore.featureFlagsAvailable &&
        this.featureFlagStore.flags.showDynamicAllegacyFees
    );
  }

  get receiptsNeededDeeplinkLocation (): HsabSsoDestination {
    return HsabSsoDestination.ReceiptsNeeded;
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }

  get showStopPayment (): boolean {
    return this.custodianSettingsStore.userCustodian === BankCustodian.HsaBank;
  }

  get showClosedAccountsLink (): boolean {
    return this.hsabAccountsStore.userHasAnyInactiveAccount;
  }

  get showUploadClaimReceipts (): boolean {
    return this.featureFlagStore.flags.bend18761AddDeepLinkToResourcesPages
        && this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }
  get showUploadClaimReceiptsActionNeeded (): boolean {
    return this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }
  get hasDocumentLinks (): boolean {
    return this.customerFormDocumentStore.isLoaded && this.customerFormDocumentStore.formDocuments
      .filter(x => x.formDocumentType === FormDocumentType.Link).length > 0;
  }
  get showLinksTab (): boolean {
    return this.featureFlagStore.featureFlagsAvailable
      && this.featureFlagStore.flags.bend19788FormDocumentLinksEnabled
      && this.hasDocumentLinks;
  }
}
